import Vue from 'vue'
var eventBus = new Vue()
var $router = null
var $store = null
eventBus.initEventBus = function(store,router){
  $store = store
  $router = router
}

Vue.prototype.$eventBus = eventBus

/**
 * in component A's method
 * bus.$emit('id-selected', 1)
 * in component B's created hook
 * bus.$on('id-selected', function (id) {})
 */
export default eventBus
